import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from 'rxjs';
import { memo } from "../util/index.js";
/**
 * @description Get the overall info for a society
 */

export function info(instanceId, api) {
  return memo(instanceId, function () {
    return api.queryMulti([api.query.society.bids, api.query.society.defender, api.query.society.founder, api.query.society.head, api.query.society.maxMembers, api.query.society.pot]).pipe(map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 6),
          bids = _ref2[0],
          defender = _ref2[1],
          founder = _ref2[2],
          head = _ref2[3],
          maxMembers = _ref2[4],
          pot = _ref2[5];

      return {
        bids: bids,
        defender: defender.unwrapOr(undefined),
        founder: founder.unwrapOr(undefined),
        hasDefender: defender.isSome && head.isSome && !head.eq(defender) || false,
        head: head.unwrapOr(undefined),
        maxMembers: maxMembers,
        pot: pot
      };
    }));
  });
}